import React from "react";
import s from "@/layouts/Layout.module.scss";

const MobileSectionSeperator = ({ order, margin }) => {
  return <div className={s.mobileSectionSeperator} style={{ order: order ?? "", margin: margin ?? "" }}></div>;
};

export default MobileSectionSeperator;
